var styleDataHash = "48f9b9bf";
const injectCss = () => {
  var css = `.LHdT2{max-height:580px;overflow:auto}._85Rj0{min-height:570px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var button_input_modal_default = {
  "content": "LHdT2",
  "modal": "_85Rj0"
};
export {
  button_input_modal_default as default,
  injectCss
};
//# sourceMappingURL=button-input-modal-scss.js.map
